<template>
  <div class="goback">
    <button class="back" @click="goback"></button>
    <div class="title">{{title}}</div>
    <div class="back-right">
      <button class="share" @click="home"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'goback',
  components: {
  },
  props: {
    title: {
      type: String
    },
    leftText: {
      type: String
    }
  },
  methods: {
    goback () {
      this.$router.back()
    },
    home () {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<style lang="less" scoped>
.goback {
  position: fixed;
  top: 0;
  width: 100%;
  font-size: @fz32;
  .flex-center;
  height: 0.6rem;
  padding: 0.2rem 0;
  background-color: #fff;
  z-index: 999;
  .back {
    position: absolute;
    left: 0.3rem;
    width: 0.6rem;
    height: 0.6rem;
    background: url('../assets/img/sku-back.png') center no-repeat;
    background-size: 100%;
  }
  .back-right {
    position: absolute;
    right: 0.3rem;
    display: flex;
    .share {
      width: 0.6rem;
      height: 0.6rem;
      background: url('../assets/img/share.png') center no-repeat;
      background-size: 100%;
    }
  }
}
</style>
